import { http } from "@/http";

// Importador de viajes desde Excel (DEF-ADM-022). La ciudad no va en el header:
// cada fila del Excel trae la suya.
export default {
  // Sube el Excel y devuelve el preview (no inserta nada).
  previewDespegar(file) {
    const data = new FormData();
    data.append("file", file);
    return http.post("/api/v1/imports/despegar", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  // Crea los viajes de los códigos elegidos a partir del último preview.
  confirmDespegar(rideCodes) {
    return http.post("/api/v1/imports/despegar/confirm", { ride_codes: rideCodes });
  },
  // Historial de importaciones confirmadas.
  logs(params) {
    return http.get("/api/v1/imports/logs", { params });
  },
};
